import { IconReceipt } from "@tabler/icons-react";
import { type ComponentType, createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const pages = () => import("./FinancePages");
const StatementsPage = lazy(() => pages().then((m) => ({ default: m.FinanceStatementsPage })));
const ProvidersPage = lazy(() => pages().then((m) => ({ default: m.FinanceProvidersPage })));
const PortalStatements = lazy(() => pages().then((m) => ({ default: m.PortalStatementsPage })));
const Detail = lazy(() => import("./SettlementDetail").then((m) => ({ default: m.SettlementDetail })));

const el = <P extends object>(c: ComponentType<P>, props: P) =>
  createElement(Suspense, { fallback: null }, createElement(c, props));

export const routes: FeatureRoute[] = [
  { path: "/admin/finance", roles: CAPS.admin.financeRead, element: el(StatementsPage, {}) },
  { path: "/admin/finance/providers", roles: CAPS.admin.financeRead, element: el(ProvidersPage, {}) },
  { path: "/admin/finance/settlements/:id", roles: CAPS.admin.financeRead, element: el(Detail, { surface: "admin" }) },
  { path: "/portal/finance/statements", roles: CAPS.portal.statements, element: el(PortalStatements, {}) },
  { path: "/portal/finance/statements/:id", roles: CAPS.portal.statements, element: el(Detail, { surface: "portal" }) },
];

export const nav: NavItem[] = [
  { label: "Finance", path: "/admin/finance", icon: IconReceipt, surface: "admin", roles: CAPS.admin.financeRead },
  {
    label: "Statements",
    path: "/portal/finance/statements",
    icon: IconReceipt,
    surface: "portal",
    roles: CAPS.portal.statements,
  },
];
